import React, { useEffect, useState } from 'react';
import "./Details.css";
import { NavLink } from 'react-router-dom';
import logoImg from '../logo.svg';
import { Icon } from 'react-icons-kit';
import { menu } from 'react-icons-kit/feather/menu';
import { eye } from 'react-icons-kit/feather/eye';
import { arrowUpRight } from 'react-icons-kit/feather/arrowUpRight'
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import { useJwt } from "react-jwt";
import { GetEmployeByEmail } from '../apiconfig/authService';

function ViewEmployee() {
    const navigate = useNavigate();
    const { _, isExpired } = useJwt(localStorage.getItem('accessToken'));
    if (isExpired)
        navigate('/');

    const [employeeData, setEmployeeData] = useState([]);
    const { employeeEmailId } = useParams();

    const formatUTCDate = (utcDateString) => {
        const date = new Date(utcDateString);
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZoneName: 'short',
        };
        const readableFormat = date.toLocaleString(undefined, options);
        return readableFormat.substring(0, readableFormat.length - 9);
    };

    useEffect(() => {
        (
            async () => {
                try {
                    const response = await GetEmployeByEmail(employeeEmailId, localStorage.getItem('accessToken'));
                    setEmployeeData(response.data[0]);
                } catch (error) {
                    console.log(error);
                }
            }
        )();
    }, []);

    return (
        <div className="dashboard-content">
            {/* <div className="mobileOption d-flex align-items-center justify-content-between">
                <div  className="buyMore"><img className="img-fluid" src={logoImg} alt=""/></div>
                <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
            </div> */}
            <Sidebar />
            <div className="body-cart tab-content dasContent p-4 bg-white rounded">
                <div className="d-flex justify-content-between align-items-center pb-4 border-bottom mb-4">
                    <h1 className="heading h4 mb-0 fw-bold">Employee Details</h1>
                    <div className="d-inline-flex gap-2">
                        <NavLink to="/employee" className="btn btn-primary addSeller px-3 me-2"><Icon className="eye" icon={eye} size={18} /> View All</NavLink>
                        <NavLink to={`/editEmployee/${employeeEmailId}`} className="btn btn-primary addSeller px-3 ms-2"><Icon className="arrowUpRight" icon={arrowUpRight} size={18} /> Edit</NavLink>
                    </div>
                </div>
                <div className="detailsBox">
                    <div className="row">
                        <div className="col">
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover w-100">
                                    <tbody>
                                        <tr>
                                            <th>First Name</th>
                                            <td>{employeeData?.firstname}</td>
                                        </tr>
                                        <tr>
                                            <th>Last Name</th>
                                            <td>{employeeData?.lastname}</td>
                                        </tr>
                                        <tr>
                                            <th>Employee Code</th>
                                            <td>{employeeData?.empcode}</td>
                                        </tr>
                                        <tr>
                                            <th>Phone Number</th>
                                            <td>{employeeData?.employeephone}</td>
                                        </tr>
                                        <tr>
                                            <th>Designation</th>
                                            <td>{employeeData?.designation}</td>
                                        </tr>
                                        <tr>
                                            <th>Email ID</th>
                                            <td>{employeeData?.emailid}</td>
                                        </tr>
                                        <tr>
                                            <th>Created Date</th>
                                            <td>{formatUTCDate(employeeData?.createddate)}</td>
                                        </tr>
                                        <tr>
                                            <th>Modified Date</th>
                                            <td>{formatUTCDate(employeeData?.modifieddate)}</td>
                                        </tr>
                                        <tr>
                                            <th>Created By</th>
                                            <td>{employeeData?.createdby}</td>
                                        </tr>
                                        <tr>
                                            <th>Modified By</th>
                                            <td>{employeeData?.modifiedby}</td>
                                        </tr>
                                        <tr>
                                            <th>Status</th>
                                            <td>{employeeData?.statusInfo?.status}</td>
                                        </tr>
                                        <tr>
                                            <th>Role</th>
                                            <td>{employeeData?.roleInfo?.role}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}
export default ViewEmployee;